/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, ButtonGroup, ButtonToolbar, Overlay } from 'react-bootstrap'
import { NodeTypes } from '../variables'
import AddClientForm from './forms/AddClientForm'
import AddAccountForm from './forms/AddAccountForm'
import { confirm } from '../../utils/confirm'
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { PersonXFill, ArrowClockwise } from 'react-bootstrap-icons'
import { FindDeviceModal } from './forms/FindDeviceForm'
import context from './context/shared'
import { ConfirmDialogProps } from '../../utils/ConfirmDialog'
import { toast } from 'react-toastify'
import { Popover } from '@base-ui-components/react/popover';
import { Dispatch, SetStateAction } from 'react'

const rootButtons = (showTitle) => {
    return <>
        <>
            <AddClientForm
                showTitle={showTitle}
            />
        </>
    </>
}
const clientButtons = (showTitle) => {
    const { currentNode, handleDeleteClient } = context;

    return <>
        <>
            <AddAccountForm
                clientId={currentNode!.id}
                showTitle={showTitle}
            />
            <Button title="Удалить клиента" onClick={handleDeleteClient} variant="transparent" ><PersonXFill fill="var(--client)" />{showTitle ? "Удалить клиента" : ""}</Button>
        </>
    </>
}
const accountButtons = (showTitle) => {
    const { handleDeleteAccount } = context;
    return <>
        <>
            <Button title="Удалить логин" onClick={handleDeleteAccount} variant="transparent" ><PersonXFill fill="var(--account)" />{showTitle ? "Удалить логин" : ""}</Button>
        </>
    </>
}
export const getNodeButtons = (nodeType, showTitle) => {
    switch (nodeType) {
        case NodeTypes.account:
            return accountButtons(showTitle);
        case NodeTypes.client:
            return clientButtons(showTitle);
        case NodeTypes.root:
        case undefined:
            return rootButtons(showTitle);
    }
}

export const ClientsTreeButtonPanel = () => {
    const { refreshTree, currentNode } = context;

    return (
        <>
            <ButtonToolbar key={currentNode?.name}>
                <ButtonGroup size='lg'>
                    <Button title="Обновить" onClick={refreshTree} variant="transparent" className="centerButton"><ArrowClockwise /></Button>
                    <FindDeviceModal />
                    {getNodeButtons(currentNode?.type, false)}
                </ButtonGroup>    
            </ButtonToolbar>        
        </>          
    );   

};